import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { makeGetFile } from '../selectors/files';
import { makeGetNotificationsByAssociationId } from '../selectors/notifications';

import { fetchFile } from '../actions/files';

import { extractId } from '../utils/helpers';

class FileContainer extends PureComponent {
    static propTypes = {
        id: PropTypes.any
    };

    constructor(props) {
        super(props);

        if (this.id) {
            this.fetchFile(this.id);
        }
    }

    fetchFile(fileId) {
        if (!fileId || (this.props.file && !(this.props.file.shouldRefetch && !this.props.file.loading))) {
            return;
        }

        fetchFile(fileId);
    }

    get id() {
        const id = extractId(this.props.id);
        if (id === 'undefined' || typeof id === 'undefined') {
            return null;
        }

        return id;
    }

    get fileProps() {
        if (!this.props.file || this.props.file.loading) {
            return {
                id: this.id,
                loading: true
            };
        }

        if (this.props.file.error) {
            return {
                id: this.id,
                error: true
            };
        }

        if (this.props.file.removed) {
            return {
                id: this.id,
                removed: true
            };
        }

        return {
            id: this.id,
            notifications: this.props.notifications,
            ...this.props.file
        };
    }

    componentDidUpdate(prevProps) {
        this.fetchFile(this.id);
    }

    render() {
        return React.Children.map(this.props.children, child => React.cloneElement(child, this.fileProps));
    }
}

const makeMapStateToProps = () => {
    const getFile = makeGetFile();
    const getNotificationsByAssociationId = makeGetNotificationsByAssociationId();

    return ({ files, notifications }, ownProps) => ({
        file: getFile(files.items, extractId(ownProps.id)),
        notifications: getNotificationsByAssociationId(notifications.items, extractId(ownProps.id)).map(notification => notification.id)
    });
}

export default connect(makeMapStateToProps)(FileContainer);
